import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody32';
import FooterNew from '../component/FooterNew';
import { Helmet } from 'react-helmet';

const CaseStudy32 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Joint Venture Proposal </h2><h4>for a Infrastructure-Focused Investment fund</h4>";

  return (
    <>
        <Helmet>
        <title>Joint Venture Proposal for a Infrastructure-Focused Investment fund</title>
        <meta property="og:title" content="Joint Venture Proposal for a Infrastructure-Focused Investment fund" />
        <meta property='og:description' content='Joint Venture Proposal for a Infrastructure-Focused Investment fund'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy32" headings={headings} />  
        <Casestudybody />
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default CaseStudy32 
